module.exports = __webpack_public_path__ + "img/08.3ebf783b.jpg";